module.exports = __webpack_public_path__ + "img/icon_printer.8dcd0ce4.svg";